import { render, staticRenderFns } from "./agent-setting.vue?vue&type=template&id=4a7d356e&"
import script from "./agent-setting.vue?vue&type=script&lang=js&"
export * from "./agent-setting.vue?vue&type=script&lang=js&"
import style0 from "./agent-setting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports